import { useEffect, useState } from 'react';
import { templatesApi } from '../../shared/api/templates.api';
import type { Template } from '../../entities/template';

/**
 * Грузит ТОЛЬКО текущий шаблон по id (GET /templates/:id), а не весь список.
 * Свежие данные с сервера при каждом входе на экран редактирования —
 * исключает показ устаревшего снапшота из общего стора.
 */
export function useTemplateForEdit(id: string | undefined): {
  template: Template | null;
  isLoading: boolean;
} {
  const [template, setTemplate] = useState<Template | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(!!id);

  useEffect(() => {
    if (!id) {
      setTemplate(null);
      setIsLoading(false);
      return;
    }

    let cancelled = false;
    setIsLoading(true);

    templatesApi
      .getById(id)
      .then((t) => {
        if (!cancelled) setTemplate(t as unknown as Template);
      })
      .catch(() => {
        if (!cancelled) setTemplate(null);
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [id]);

  return { template, isLoading };
}
